import * as z from "zod/v4";

export enum ConvertBoxlessTokenError {
  ExpiredToken = "ExpiredToken",
  InvalidToken = "InvalidToken",
}

export const convertBoxlessTokenToCustomerAuth = {
  name: "convertBoxlessTokenToCustomerAuth" as const,
  input: z.object({ boxlessReturnsLocationsToken: z.string() }),
  output: z.object({ customerAuthToken: z.string(), returnId: z.string() }),
};
